/* Prime Armor Theme — JS v3 i18n */
(function() {
  'use strict';

  var i18n = window.i18n || {
    add_to_cart: 'Add to cart',
    adding: 'Adding...',
    added: 'Added!',
    error: 'Error — try again',
    sold_out: 'Sold out',
    cart_empty: 'Your cart is empty.',
    view_products: 'View products',
    subtotal: 'Subtotal',
    checkout: 'Checkout',
    view_cart: 'View cart'
  };

  /* ---- Announcement bar + header offset ---- */
  var annBar = document.querySelector('.announcement-bar');
  var header = document.querySelector('.site-header');
  if (annBar) {
    document.body.classList.add('has-announcement');
    function syncAnnHeight() {
      document.documentElement.style.setProperty('--ann-h', annBar.offsetHeight + 'px');
    }
    syncAnnHeight();
    window.addEventListener('resize', syncAnnHeight);
  }

  /* ---- Header scroll ---- */
  if (header) {
    function onScroll() {
      var threshold = annBar ? annBar.offsetHeight + 10 : 10;
      header.classList.toggle('scrolled', window.scrollY > threshold);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Mobile menu ---- */
  var mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  var mobileNav = document.querySelector('.mobile-nav');
  var mobileClose = document.querySelector('.mobile-nav-close');
  function openMobileNav() { mobileNav && mobileNav.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeMobileNav() { mobileNav && mobileNav.classList.remove('open'); document.body.style.overflow = ''; }
  mobileMenuBtn && mobileMenuBtn.addEventListener('click', openMobileNav);
  mobileClose && mobileClose.addEventListener('click', closeMobileNav);
  mobileNav && mobileNav.querySelectorAll('a').forEach(function(a) { a.addEventListener('click', closeMobileNav); });

  /* ---- Cart drawer ---- */
  var cartOverlay = document.querySelector('.cart-overlay');
  var cartDrawer = document.querySelector('.cart-drawer');
  var cartClose = document.querySelector('.cart-drawer-close');
  function openCart(e) {
    e && e.preventDefault();
    cartOverlay && cartOverlay.classList.add('open');
    cartDrawer && cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCart() {
    cartOverlay && cartOverlay.classList.remove('open');
    cartDrawer && cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('.cart-icon').forEach(function(btn) { btn.addEventListener('click', openCart); });
  cartClose && cartClose.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  /* ---- Cart fetch ---- */
  function fetchCart() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(renderCart).catch(function() {});
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents, window.theme_money_format || '{{amount}} {{currency_iso}}');
    return (cents / 100).toFixed(2);
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function renderCart(cart) {
    var body = document.querySelector('.cart-drawer-body');
    var subtotal = document.querySelector('.cart-subtotal span:last-child');
    if (!body) return;
    updateCartCount(cart.item_count);
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><p>' + i18n.cart_empty + '</p><a href="/collections/all" class="btn btn--primary" style="margin-top:20px;display:inline-flex;">' + (i18n.view_products || 'View products') + '</a></div>';
      return;
    }
    body.innerHTML = cart.items.map(function(item) {
      return '<div class="cart-item"><div class="cart-item-img">' + (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '') + '</div><div class="cart-item-info"><div class="cart-item-title">' + escapeHtml(item.product_title) + '</div>' + (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-item-variant">' + escapeHtml(item.variant_title) + '</div>' : '') + '<div class="cart-item-price">' + formatMoney(item.line_price) + '</div></div><button class="cart-drawer-close" style="font-size:16px;margin-left:auto;align-self:flex-start;" onclick="removeCartItem(\'' + item.key + '\')" aria-label="Remove">✕</button></div>';
    }).join('');
  }

  window.removeCartItem = function(key) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) }).then(fetchCart).catch(function() {});
  };

  /* ---- Add to cart ---- */
  document.querySelectorAll('.btn-add-cart, [data-add-to-cart]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var form = btn.closest('form') || document.querySelector('[data-product-form]');
      var variantId = form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value;
      if (!variantId) return;
      var origText = btn.textContent;
      btn.textContent = i18n.adding;
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }) })
        .then(function(r) { if (!r.ok) throw new Error('failed'); return r.json(); })
        .then(function() {
          btn.textContent = i18n.added;
          setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 1800);
          openCart();
        }).catch(function() {
          btn.textContent = i18n.error;
          btn.disabled = false;
          setTimeout(function() { btn.textContent = origText; }, 2500);
        });
    });
  });

  /* ---- Gallery thumbnails ---- */
  document.querySelectorAll('.product-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var main = document.querySelector('.product-gallery-main img');
      var newSrc = thumb.dataset.src || (thumb.querySelector('img') && thumb.querySelector('img').src);
      if (main && newSrc) main.src = newSrc;
      document.querySelectorAll('.product-thumb').forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  /* ---- Variant selection ---- */
  document.querySelectorAll('.option-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var group = btn.closest('.option-buttons');
      group.querySelectorAll('.option-btn').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      updateSelectedVariant();
    });
  });

  function updateSelectedVariant() {
    if (!window.productVariants || !window.productVariants.length) return;
    var selected = {};
    document.querySelectorAll('.option-buttons').forEach(function(group) {
      var active = group.querySelector('.option-btn.active');
      if (active) selected[group.dataset.option] = active.dataset.value;
    });
    var match = window.productVariants.find(function(v) {
      return Object.entries(selected).every(function(e) { return v.options[e[0]] === e[1]; });
    });
    if (!match) return;
    var idInput = document.querySelector('[name="id"]');
    if (idInput) idInput.value = match.id;
    var priceEl = document.querySelector('.product-price');
    if (priceEl) priceEl.textContent = formatMoney(match.price);
    var addBtn = document.querySelector('.btn-add-cart');
    if (addBtn) { addBtn.disabled = !match.available; addBtn.textContent = match.available ? i18n.add_to_cart : i18n.sold_out; }
  }

  /* ---- Scroll animations ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { entry.target.style.animationPlayState = 'running'; io.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.animate-up').forEach(function(el) { el.style.animationPlayState = 'paused'; io.observe(el); });
  }

  fetchCart();
})();
